const app = "سرنخ";
const _app = app + " | ";

export const webPagesTitle = {
  splash_screen: app,

  insert_mobile: _app + "ورود با شماره موبایل",
  verify_code: _app + "کد تایید",
  home_stack: app,
  home: app,
  profile: _app + "اطلاعات کاربری",
  company_profile: _app + "اطلاعات شرکت",
  contact_us: _app + "ارتباط با سرنخ",
  about_us: _app + "درباره سرنخ",
  organization: _app + "سازمان",
  employee_permissions: _app + "دسترسی های کارمند",
  corp: _app + "اطلاعات شرکت",
  add_corp: _app + "افزودن شرکت",
  corps: _app + "شرکت ها",
  attributes: _app + "ویژگی ها",
  attribute: _app + "اطلاعات ویژگی",
  categories: _app + "گروه ها",
  category: _app + "اطلاعات گروه",
  CEO: _app + "مدیر عامل",
  CEOs: _app + "مدیران عامل",
  report: _app + "گزارش",
  reports: _app + "گزارش",
  customer_report: _app + "گزارش مشتریان",
  product: _app + "اطلاعات محصول",
  products: _app + "محصولات",
  customers: _app + "مشتری ها",
  customer: _app + "اطلاعات مشتری",
  factor: _app + "اطلاعات سفارش",
  add_new_factor_items: _app + "اطلاعات سفارش",
  factor_pdf: "خروجی فاکتور",
  factors: _app + "سفارسات و فاکتورها",
  note: _app + "اطلاعات یادداشت",
  notes: _app + "یادداشت ها",

  user: _app + "اطلاعات کاربر",
  users: _app + "کاربران",

  apk_version: _app + "ورژن برنامه",
  type_of_meeting: _app + "نحوه آشنایی",

  companies: _app + "شرکت های همکار",
  company: _app + "اطلاعات شرکت",

  wholesalers: _app + "بنکداران ",
  wholesaler: _app + "اطلاعات بنکدار",
  reminders: _app + "اطلاعات یادآور",
  reminder: _app + "یادآورها",

  countries: _app + "کشورها",
};
